export default __webpack_public_path__ + "static/media/mail-sp.479bca0a.webp";